import { faFileImage } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const VerifyUploadSection = ({ uploadMedia, verifyMedia, inputRef }) => {
  return (
    <div className="upload-section">
      <h4>Upload to verify asset</h4>
      <div className="upload-icon">
        <FontAwesomeIcon
          size="3x"
          icon={faFileImage}
          style={{ color: '#0daa85' }}
        />
      </div>
      <button onClick={uploadMedia}>Upload</button>
      <input
        ref={inputRef}
        type="file"
        id="upload"
        style={{ display: 'none' }}
        onChange={verifyMedia}
      />
    </div>
  )
}

export default VerifyUploadSection
